import { render, staticRenderFns } from "./updateSubCategory.vue?vue&type=template&id=583fee7e"
import script from "./updateSubCategory.vue?vue&type=script&lang=js"
export * from "./updateSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports